import { useDispatch, useSelector } from "react-redux";
import { downloadMonthlyDateExcel } from "../thunks/downloadMonthlyDateReportExcel";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useMonthlyDateExcelDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.monthlyTrade.downloadReportFetchState
  );

  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadMonthlyDateExcel()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
